<div class="gallery-container">
  <div class="img-container" *ngIf="!images?.length">
    <img src="assets/img/logo/logo.png" alt="La Caverne Du Gobelin"/>
  </div>
  <div class="img-container" *ngIf="images?.length"
    (mouseenter)="onZoomEnter($event)"
    (mouseleave)="onZoomLeave()"
    (mousemove)="onZoomMove($event)"
  >
    <img [src]="getImage(indImg)" [alt]="images[indImg]?.name" class="main-img" #mainImg/>

    <span *ngIf="product.isUsed" class="stamp-container">
      <gob-stamp></gob-stamp>
    </span>

    <!-- Icône loupe (hint visuel) -->
    <span class="zoom-hint" *ngIf="!isZooming">
      <i class="fa-regular fa-magnifying-glass-plus"></i>
    </span>

    <!-- Bulle loupe -->
    <div class="zoom-lens" *ngIf="isZooming" [ngStyle]="lensStyle"></div>
  </div>

  <div *ngIf="images?.length" class="thumbnails">
    <div
      class="thumbnail"
      *ngFor="let img of images; let i = index; trackBy: trackImage"
      (click)="indImg = i"
      [class.active]="i === indImg"
    >
      <img [src]="getImage(i)" [alt]="img.name"/>
    </div>
  </div>
</div>